import { Stack } from '@mui/material';
import { clientCuisine } from 'api/client-domain/fixtures/client-cuisine.fixture';
import {
  benchmarksMetricsFixture,
  benchmarksOverviewFixture,
} from 'api/reports-service/fixtures/benchmarks.fixture';
import { useTranslation } from 'react-i18next';
import BenchmarksKpiCards from './benchmarks-kpi-cards.component';
import BenchmarksMetricsGrid from './benchmarks-metrics-grid.component';
import {
  buildBrandCuisineKpiCard,
  toBenchmarksKpiCards,
} from './benchmarks.utils';

// The preview bypasses the query, so it applies the same overview transform the
// endpoint does (map the wire card DTOs to the shared KpiCard shape).
const previewCards = toBenchmarksKpiCards(benchmarksOverviewFixture);

/**
 * Static, fixture-backed render of the Benchmarks tab — no queries, no fetch.
 * Shown blurred behind the Data Plus paywall so the locked state still looks
 * like a populated report. Reuses the real presentational components, including
 * the FE-built Brand Cuisine KPI (fixture cuisine) as the leading card.
 */
const BenchmarksLockedPreview = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} data-testid="GuestJourney.Benchmarks.LockedPreview">
      <BenchmarksKpiCards
        leadingCard={buildBrandCuisineKpiCard(t, clientCuisine.displayTitle)}
        cards={previewCards}
      />
      <BenchmarksMetricsGrid sections={benchmarksMetricsFixture} />
    </Stack>
  );
};

export default BenchmarksLockedPreview;
